<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('system_layout')"></pageTitle>
        <Row :gutter="50">
          <Col span="5">
            <Menu :active-name="tabs" width @on-select="select">
              <MenuItem name="1">{{ $t("Integral_set") }}</MenuItem>
              <MenuItem name="2">{{ $t("Welcome_reward") }}</MenuItem>
              <MenuItem name="3">{{ $t("shop_welcome_set") }}</MenuItem>
            </Menu>
          </Col>
          <Col span="19">
            <Col span="12" v-if="tabs == 1">
              <Form ref="form" :model="form" :rules="ruleInline" label-position="top">
                <FormItem :label="$t('Credit_time')" prop="effective_time">
                  <InputNumber :min="1" v-model="form.effective_time" placeholder></InputNumber>
                </FormItem>
                <FormItem :label="$t('Integral_transform')" prop="equivalent_value">
                  <InputNumber :min="1" v-model="form.equivalent_value" placeholder></InputNumber>
                </FormItem>
                <FormItem :label="$t('PointInt')" prop="count">
                  <InputNumber :min="1" v-model="form.count" placeholder></InputNumber>
                </FormItem>
                <FormItem>
                  <Col class="butList">
                    <Button type="primary" @click="handleSubmit('form')">{{ $t("preserve") }}</Button>
                  </Col>
                </FormItem>
              </Form>
            </Col>
            <Col span="12" v-if="tabs == 2">
              <Tabs @on-click="onClick">
                <TabPane
                  :value="tab"
                  v-for="(item, i) in roles"
                  :key="i"
                  :label="item.value"
                  :name="item.key"
                />
              </Tabs>
              <Form
                v-if="roles.length > 0"
                ref="rolesForm"
                :rules="ruleInline2"
                :model="rolesForm"
                label-position="top"
              >
                <FormItem prop="begin_time" :label="$t('time_fr')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :placeholder="$t('time_fr_input')"
                    v-model="rolesForm.begin_time"
                    @on-change="changeDate"
                  ></DatePicker>
                </FormItem>
                <FormItem prop="end_time" :label="$t('time_to')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :placeholder="$t('time_to_input')"
                    v-model="rolesForm.end_time"
                    @on-change="changeDate2"
                  ></DatePicker>
                </FormItem>
                <FormItem :label="$t('PresentExp')" prop="count">
                  <InputNumber :min="1" v-model="rolesForm.count" placeholder></InputNumber>
                </FormItem>
                <FormItem>
                  <Col class="butList">
                    <Button type="primary" @click="handleSubmit('rolesForm')">{{ $t("preserve") }}</Button>
                  </Col>
                </FormItem>
              </Form>
            </Col>
            <Col span="12" v-if="tabs == 3">
              <Form ref="form" :model="shopForm" :rules="ruleInline3" label-position="top">
                <FormItem :label="$t('Reward_Type')">
                  <RadioGroup v-model="type" @on-change="change">
                    <Radio :label="1">{{ $t('amount_bonus') }}</Radio>
                    <Radio :label="2">{{ $t('Reward_ratio') }}</Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem v-if="type == 1" prop="count" :label="$t('amount_bonus')">
                  <InputNumber
                    :min="1"
                    v-model="shopForm.count"
                    :placeholder="$t('amount_bonus_input')"
                  ></InputNumber>
                </FormItem>
                <FormItem v-else prop="multiple" :label="$t('Reward_ratio')">
                  <InputNumber
                    :min="1"
                    v-model="shopForm.multiple"
                    :placeholder="$t('Reward_ratio_input')"
                  ></InputNumber>
                </FormItem>
                <FormItem prop="days" :label="$t('member_day')">
                  <InputNumber
                    :min="1"
                    v-model="shopForm.days"
                    :placeholder="$t('member_day_input')"
                  ></InputNumber>
                </FormItem>
                <FormItem prop="begin_time" :label="$t('time_fr')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :placeholder="$t('time_fr_input')"
                    v-model="shopForm.begin_time"
                    @on-change="changeDate3"
                  ></DatePicker>
                </FormItem>
                <FormItem prop="end_time" :label="$t('time_to')">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :placeholder="$t('time_to_input')"
                    v-model="shopForm.end_time"
                    @on-change="changeDate4"
                  ></DatePicker>
                </FormItem>
                <FormItem :label="$t('content') + '(简体)'" prop="zh-cn_remark">
                  <Input
                    type="text"
                    v-model="shopForm['zh-cn_remark']"
                    :placeholder="$t('content_input')"
                  ></Input>
                </FormItem>
                <FormItem :label="$t('content') + '(繁体)'" prop="zh-tw_remark">
                  <Input
                    type="text"
                    v-model="shopForm['zh-tw_remark']"
                    :placeholder="$t('content_input')"
                  ></Input>
                </FormItem>
                <FormItem :label="$t('content') + '(en)'" prop="en_remark">
                  <Input
                    type="text"
                    v-model="shopForm.en_remark"
                    :placeholder="$t('content_input')"
                  ></Input>
                </FormItem>
                <FormItem>
                  <Col class="butList">
                    <Button type="primary" @click="handleSubmit('form')">{{ $t("preserve") }}</Button>
                  </Col>
                </FormItem>
              </Form>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import moment from "moment"
export default {
  name: "setup",
  components: {
    pageTitle
  },
  data () {
    const validateDate = (rule, value, callback) => {
      if (value == '' || value == null) {
        callback(new Error(this.$t('time_fr_input')));
      } else {
        callback();
      }
    };
    const validateDate2 = (rule, value, callback) => {
      if (value == '' || value == null) {
        callback(new Error(this.$t('time_to_input')));
      } else {
        callback();
      }
    };
    return {
      tabs: "1",
      tab: "1",
      type: 1,
      form: {
        config_id: 1,
        effective_time: null,
        count: null,
        equivalent_value: null
      },
      rolesForm: {
        role_id: 1,
        count: null,
        begin_time: "",
        end_time: ""
      },
      shopForm: {
        id: '',
        count: 0,
        days: null,
        multiple: 0,
        begin_time: "",
        end_time: "",
        en_remark: "",
        'zh-cn_remark': "",
        'zh-tw_remark': ""
      },
      data: [],
      ruleInline: {
        count: [
          {
            type: 'number',
            required: true,
            message: this.$t('Integral_transform_input'),
            trigger: 'blur'
          }
        ],
        effective_time: [
          {
            type: 'number',
            required: true,
            message: this.$t('effective_time_input'),
            trigger: 'blur'
          }
        ],
        equivalent_value: [
          {
            type: 'number',
            required: true,
            message: this.$t('equivalent_value_input'),
            trigger: 'blur'
          }
        ],
      },
      ruleInline2: {
        count: [
          {
            type: 'number',
            required: true,
            message: this.$t('PresentExp_input'),
            trigger: 'blur'
          }
        ],
        begin_time: [
          { required: true, validator: validateDate, message: this.$t('time_fr_input'), trigger: 'change' }
        ],
        end_time: [
          { required: true, validator: validateDate2, message: this.$t('time_to_input'), trigger: 'change' }
        ],
      },
      ruleInline3: {
        "zh-cn_remark": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: 'blur'
          }
        ],
        "zh-tw_remark": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: 'blur'
          }
        ],
        en_remark: [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: 'blur'
          }
        ],
        count: [
          {
            type: 'number',
            required: true,
            message: this.$t('amount_bonus_input'),
            trigger: 'blur'
          }
        ],
        multiple: [
          {
            type: 'number',
            required: true,
            message: this.$t('Reward_ratio_input'),
            trigger: 'blur'
          }
        ],
        days: [
          {
            type: 'number',
            required: true,
            message: this.$t('amount_bonus_input'),
            trigger: 'blur'
          }
        ],
        begin_time: [
          {
            required: true,
            validator: validateDate,
            message: this.$t('time_fr_input'),
            trigger: 'change'
          }
        ],
        end_time: [
          {
            required: true,
            validator: validateDate2,
            message: this.$t('time_to_input'),
            trigger: 'change'
          }
        ],
      },
      roles: []
    };
  },
  created () {
    this.info()
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    select (e) {
      this.tabs = e
    },
    onClick (e) {
      this.tab = e
      this.data[this.tab - 1].count = this.data[this.tab - 1].count * 1
      this.rolesForm = this.data[this.tab - 1]
    },
    change (e) {
      this.type = e;
      if (this.type == 1) this.shopForm.multiple = 0
      else this.shopForm.count = 0
    },
    changeDate (e) {
      this.rolesForm.begin_date = e;
    },
    changeDate2 (e) {
      this.rolesForm.end_date = e;
    },
    changeDate3 (e) {
      this.shopForm.begin_time = e;
    },
    changeDate4 (e) {
      this.shopForm.end_time = e;
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.tabs == 1 ? 'sys-config/upd' : this.tabs == 2 ? 'sys-config/upd_welcome' : 'sys-config/upd_mall',
            this.tabs == 1 ? this.form : this.tabs == 2 ? this.rolesForm : this.shopForm,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.info()
              this.onOk();
            }
          );
        } else {
          this.error()
        }
      })
    },
    info () {
      this.getSysConfig()
      this.getWelcomeConfig()
      this.getShopConfig()
    },
    getSysConfig () {
      this.$base.showLoading();
      this.$request.sendPost(
        'sys-config/before-upd', {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          if (data.sys_config != "") {
            data.sys_config.effective_time = data.sys_config.effective_time * 1 || 0
            data.sys_config.count = data.sys_config.count * 1 || 0
            data.sys_config.equivalent_value = data.sys_config.equivalent_value * 1 || 0
            this.form = data.sys_config
          }
        }
      );
    },
    getWelcomeConfig () {
      this.$base.showLoading();
      this.$request.sendPost(
        'sys-config/welcome-before-upd', {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.roles = data.roles
          if (JSON.stringify(data.welcome_config) != '[]') {
            this.data = data.welcome_config
            this.data[this.tab - 1].count = this.data[this.tab - 1].count * 1
            this.rolesForm = this.data[this.tab - 1]
          }
        }
      );
    },
    getShopConfig () {
      this.$base.showLoading();
      this.$request.sendPost(
        'sys-config/mall-before-upd', {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          if (data.mall_config != "") {
            data.mall_config.count = data.mall_config.count * 1 || 0
            data.mall_config.days = data.mall_config.days * 1 || 0
            data.mall_config.multiple = data.mall_config.multiple * 1 || 0
            this.shopForm = data.mall_config
            if (this.shopForm.multiple > 0) this.type = 2
            else this.type = 1
          }

        }
      );
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .butList {
    text-align: right;
  }

  .ivu-tabs-bar {
    border: none;
    margin-bottom: 20px;
  }

  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/setup/setup.vue